import React from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import DefaultFilterBar from "../../../../components/DataTable/FilterBar";
import Button from "../../../../components/Button";
import TextField from "../../../../components/TextField";
import validate from "./validation";
import axios from "axios";

import { ExportToExcel } from "./ExportToExcel";
import { getCookie } from "../../../../services/useAuthentication";

const propTypes = {
  onFilter: PropTypes.func.isRequired,
};

function FilterBar(props) {
  const { onFilter } = props;
  const filterParams = {
    name: null,
  };
  const [filter, setFilter] = React.useState(filterParams);
  const [errors, setErrors] = React.useState({});

  function changeFilter(event) {
    const { target } = event;
    const { name, value } = target;
    setFilter({
      ...filter,
      [name]: value.replace(/[`~!@#$%^&*()_|+\=?;:'",<>\{\}\[\]\\\/]/gi, ""),
    });
  }

  async function handleFilter() {
    setErrors({});
    const result = await validate(filter);
    if (!result.isValid) {
      setErrors(result.errors);
      return;
    }
    onFilter({ ...filter });
  }

  function handleReset() {
    setErrors({});
    setFilter(filterParams);
    onFilter({});
  }

  const [data, setData] = React.useState([]);
  const fileName = "";

  React.useEffect(() => {
    const BASE_URL = process.env.RAZZLE_API_URL;
    const token = getCookie("sessionId");

    const fetchData = () => {
      axios
        .get(`${BASE_URL}/service/v1/collaborators-analytics`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((r) => {
          setData(r.data.body.data);
        });
    };
    fetchData();
  }, []);

  return (
    <DefaultFilterBar>
      <Grid container item xs="auto" spacing={1}>
        <Grid item xs={12} sm>
          <TextField
            type="text"
            label="Nombre, apellido o documento"
            name="text"
            value={filter.text || ""}
            onChange={changeFilter}
            margin="dense"
            error={!!errors.name}
            helperText={errors.name}
          />
        </Grid>
        <Grid item xs={6} sm="auto">
          <Button color="primary" fullWidth square onClick={handleFilter}>
            Filtrar
          </Button>
        </Grid>
        <Grid item xs={6} sm="auto">
          <Button color="secondary" fullWidth onClick={handleReset} square>
            Reiniciar
          </Button>
        </Grid>
        <ExportToExcel apiData={data} fileName={fileName} />
      </Grid>
    </DefaultFilterBar>
  );
}

FilterBar.propTypes = propTypes;

export default FilterBar;
